import React from "react";
import { Bookmark } from "lucide-react";
import useBookmarks from "../hooks/useBookmarks";
import { toast } from "sonner";

// variant: 'overlay' (floating over an image) | 'inline' (row button)
const BookmarkButton = ({ type, id, variant = "overlay", label }) => {
  const { isSaved, toggle } = useBookmarks();
  const saved = isSaved(type, id);

  const handle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const nowSaved = toggle(type, id);
    toast(nowSaved ? "Saved to your reading list" : "Removed from your list");
  };

  if (variant === "inline") {
    return (
      <button
        onClick={handle}
        aria-label={saved ? "Remove from reading list" : "Save for later"}
        className={`inline-flex items-center gap-2 font-sans-ui text-sm px-5 py-3 rounded-full border transition-colors ${
          saved
            ? "bg-neutral-900 text-white border-neutral-900"
            : "bg-transparent text-neutral-800 border-neutral-300 hover:border-neutral-900"
        }`}
      >
        <Bookmark size={16} fill={saved ? "currentColor" : "none"} />
        {label || (saved ? "Saved" : "Save for later")}
      </button>
    );
  }

  return (
    <button
      onClick={handle}
      aria-label={saved ? "Remove from reading list" : "Save for later"}
      className={`absolute top-3 left-3 z-10 w-10 h-10 rounded-full flex items-center justify-center backdrop-blur transition-colors ${
        saved
          ? "bg-neutral-900 text-white"
          : "bg-white/80 text-neutral-900 hover:bg-white"
      }`}
    >
      <Bookmark size={17} fill={saved ? "currentColor" : "none"} />
    </button>
  );
};

export default BookmarkButton;
